// extracted by mini-css-extract-plugin
module.exports = {"productSize":"Size_productSize__22nxv","sizeText":"Size_sizeText__j5Ew5","sizes":"Size_sizes__TPoiV","disable":"Size_disable__3Dowu"};